/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   media bizo Youtube selectors
 */

import type { Media } from '@zcode/bizos'
import { memoizeSelector } from '@zcode/memoizers'
import { compose } from 'redux'

const YOUTUBE_ID_RE =
  /^.*((?:youtu.be\/)|(?:v\/)|(?:\/u\/\w\/)|(?:embed\/)|(?:watch\?))\??v?=?([^#&?]*).*/

export const selectYoutubeId = memoizeSelector((media: Media | undefined) => {
  const { isVideo, originUrl } = media || {}
  const youtubeMatch = originUrl ? originUrl.match(YOUTUBE_ID_RE) : null
  if (isVideo && youtubeMatch && youtubeMatch.length >= 3 && youtubeMatch[2].length === 11) {
    return youtubeMatch[2]
  }

  return null
})

export const selectYoutubeEmbedUrl = compose(
  (id) => (id ? `https://www.youtube-nocookie.com/embed/${id}?rel=0&showinfo=0` : null),
  selectYoutubeId
)

export const selectYoutubeImage = compose(
  (id) => (id ? `https://img.youtube.com/vi/${id}` : null),
  selectYoutubeId
)

export const selectYoutubeThumbnail = compose(
  (image) => (image ? `${image}/default.jpg` : null),
  selectYoutubeImage
)

export const selectYoutubeMqImage = compose(
  (image) => (image ? `${image}/mqdefault.jpg` : null),
  selectYoutubeImage
)

export const selectYoutubeHqImage = compose(
  (image) => (image ? `${image}/hqdefault.jpg` : null),
  selectYoutubeImage
)

export const selectYoutubeStandardImage = compose(
  (image) => (image ? `${image}/sddefault.jpg` : null),
  selectYoutubeImage
)

export const selectYoutubeMaxResImage = compose(
  (image) => (image ? `${image}/maxresdefault.jpg` : null),
  selectYoutubeImage
)
